import { TableCell, TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import MatxTableCell from "./MatxTableCell";

import styles from "../../../../styles.module.css"; // Importing CSS module for styles.

const useStyles = makeStyles(({ palette, ...theme }) => ({
  iconHead: {},

  tableCellStyles: {
    [theme.breakpoints.down("md")]: {
      fontSize: "0.7rem",
    },
  },
}));

function MatxTableHead({ headCells, dropDown }) {
  const classes = useStyles();

  return (
    <TableRow>
      {dropDown ? <TableCell className={classes.iconHead} /> : <></>}
      {headCells?.map((headCell, index) => (
        <MatxTableCell
          key={headCell.id}
          align={headCell.align}
          className={styles.tableHeaderStyles}
        >
          {headCell.label}
        </MatxTableCell>
      ))}
    </TableRow>
  );
}

export default MatxTableHead;
